import React from "react";
import Layout from "../layout/layout";
import Breadcrumbs from "../components/Breadcrumbs";
import Seo from "../layout/seo";
import PodcastStory from "./podcast_story";
import PodcastSection from "./podcast_section";
import Podcastlisting from "./podcastlisting";
import Podcastbg from "./podcastbg";
import Featured from "../home/featured";
import Partner from "../home/partner";
import Banner from "./banner";

function Index(props) {
  return (
    <Layout>
      <>
        <Seo
          title="Technology for a change"
          description="We discuss the latest trends and technologies with entrepreneurs and global business tycoons. Subscribe to our podcast to get meaningful business insights and stay updated with the hottest technology trends worldwide!"
        />
        <Breadcrumbs
          link1="Home"
          link2="Podcast"
          show="yes"
          url1="/"
          url2="/podcast"
        />
        <Banner />
        <PodcastStory />
        <Podcastbg />
        <PodcastSection />
        <Podcastlisting />
        <Featured />
        <Partner />
      </>
    </Layout>
  );
}

export default Index;
